import { gql } from "@apollo/client";

const CHECK_CREDIT_MEMO_DOCUMENT_NUMBER = gql`
  query CheckCreditMemoDocumentNumber($params: CheckCreditMemoDocumentNumberParams!) {
    checkCreditMemoDocumentNumber(params: $params) {
      exists
      documentNumber
    }
  }
`;

export default CHECK_CREDIT_MEMO_DOCUMENT_NUMBER;
